module.exports = __webpack_public_path__ + "img/multiplier_0_en.3a43f4cb.png";